import support01 from "../imgs/support/support01.png";
import support02 from "../imgs/support/support02.png";
import support03 from "../imgs/support/support03.1.png";
import support02_1 from "../imgs/support/support02.1.svg";
import support02_2 from "../imgs/support/support02.2.svg";
import appStore from "../imgs/support/AppStore.svg";
import googleStore from "../imgs/support/GooglePlay.svg";

export const supportCardData = [
    {
        id: 100,
        img: support01,
        title: "22 Pushups",
        textDes:
            "22 Pushups is developed by OliveX HK and was first released for download in May 2017. The app utilizes the smartphone’s light sensor to automatically count a user’s push-up exercises. This has been one of OliveX’s most successful apps and achieved recognition as ‘App of the Day’ on the Apple Store.",
        imgLink1: {
            href: "https://apps.apple.com/app/22-pushups/id1227680743",
            img: appStore,
        },
        imgLink2: null,
    },
    {
        id: 101,
        img: support02,
        title: "Dustland Rider",
        textDes:
            "Dustland Rider is the coming cycling fitness gameplay which combine SOL Cycling and DOSE to provide entire new experience of Spin To Win, Cycle for Reward. SOL Cycling gives users a new cycling experience on Mars. Ride or run at your own pace with the NASA Rover, or sweat your way through the SOL story! The full version will provide users with more terrains, routes, story missions and models., especially the merge with DOSE so users can get token for reward when cycling.",
        imgLink1: {
            href: "https://store.steampowered.com/app/1431340/SOL_Cycling/",
            img: support02_1,
        },
        imgLink2: {
            href: "https://store.steampowered.com/app/1431340/SOL_Cycling/",
            img: support02_2,
        },
    },
];

export const supportCardLargeData = {
    id: 3,
    img: support03,
    title: "DUSTLAND RUNNER",
    textDes:
        "Dustland Runner is the world’s first Proof of Workout audio game, where going on runs in the real world progresses the narrative and gets you virtual rewards (NFTs / DOSE tokens) that you can use to upgrade and progress your adventure.An entirely new Run to Earn fitness game based on technology from Zombies, Run!™, the world’s leading gamified health and fitness app with an average 300,000 active users / 50,000 paid subscribers per month.",
    imgLink1: {
        href: "https://play.google.com/store/apps/details?id=com.sixtostart.zombiesrunclient",
        img: googleStore,
    },
    imgLink2: {
        href: "http://appstore.com/zombiesrun",
        img: appStore,
    },
};
